import React from "react";

export default function TextTaskInput({ task, value, onChange, error }) {
  const isLong = task.title && task.title.length > 50;
  return (
    <div className="task-item">
      <label>
        {task.title}
        {task.mandatory && <span className="required">*</span>}
      </label>
      {isLong ? (
        <textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
      {error && <div className="error-text">{error}</div>}
    </div>
  );
}
